const state = {
    trans: {},
    attachedUsers: {},
    pendingInvites: {},
    attachingUsers: {},
    detachingUsers: {},
    portalUsers: {},
    currentUser: null,
    ownerUser: null,
    isUserSelectModalShown: false,
    isConfirmationModalShown: false,
    isUserLimitExceededModalShown: false,
    userLimit: 0,
};

const getters = {
    trans: state => state.trans,
    pendingInvitesExists: state => !!Object.keys(state.pendingInvites).length,
    attachingUsersExist: state => !!Object.keys(state.attachingUsers).length,
    detachingUsersExists: state => !!Object.keys(state.detachingUsers).length,
    portalUsersExists: state => !!Object.keys(state.portalUsers).length,
    totalUsers: state => Object.keys(state.attachingUsers).length
        + Object.keys(state.pendingInvites).length
        + Object.keys(state.attachedUsers).length,
    isUserLimitInfinite: state => state.userLimit === "*",
    isUserLimitExceeded: state => {
        if (getters.isUserLimitInfinite(state)) {
            return false;
        }

        return getters.totalUsers(state) > state.userLimit;
    },
    isBlockedByUserLimit: state => {
        if (getters.isUserLimitInfinite(state)) {
            return false;
        }

        return getters.totalUsers(state) >= state.userLimit;
    },
};

const actions = {
    setTrans: ({commit}, trans) => commit('setTrans', trans),
    /**
     * Сеттер списка прикрепленных пользователей
     * @param commit
     * @param state
     * @param users
     * @returns {*}
     */
    setAttachedUsers: ({commit, state}, users) => {
        commit('setAttachedUsers', users)

        if (state.currentUser) {
            commit('disableUser', {
                list: 'attachedUsers',
                id: state.currentUser,
            })
        }
    },

    /**
     * Сеттер списка пользователей портала
     * @param commit
     * @param users
     * @returns {*}
     */
    setPortalUsers: ({commit}, users) => {
        let usersCopy = _.cloneDeep(users);

        for (let email in usersCopy) {
            let disableRequired = state.attachedUsers[email]
                || state.detachingUsers[email]
                || state.pendingInvites[email];

            if (disableRequired) {
                usersCopy[email].isDisabled = true;
            }
        }

        commit('setPortalUsers', usersCopy)
    },

    /**
     * Сеттер списка приглашений
     * @param commit
     * @param invites
     * @returns {*}
     */
    setPendingInvites: ({commit}, invites) => {
        let value = _.isEmpty(invites) ? {} : _.cloneDeep(invites);

        commit('setPendingInvites', value)
    },

    /**
     * Удаление пользователя портала
     * @param commit
     * @param state
     * @param data {object}:
     *      data.list {string} - наименование state из которого удаляем
     *      data.id {string} - идентификатор (ключ) пользователя, по умолчанию email
     * @returns {*}
     */
    detachUser: ({commit, state}, data) => {
        let userDataCopy = _.cloneDeep(state[data.list][data.id]);

        switch (data.list) {
            case 'attachedUsers':
            case 'pendingInvites':
                userDataCopy['src'] = data.list;
                commit('addUser', {
                    list: 'detachingUsers',
                    data: {id: data.id, ...userDataCopy},
                });

                break;

            case 'detachingUsers':
                if (getters.isBlockedByUserLimit(state)) {
                    commit('showUserLimitExceededModal')
                    return;
                }

                commit('addUser', {
                    list: userDataCopy['src'],
                    data: {id: data.id, ...userDataCopy},
                });

                break;

            case 'attachingUsers':
                if (getters.portalUsersExists(state)) {
                    commit('deselectUser', {
                        list: 'portalUsers',
                        id: data.id,
                    });
                }

                break;
        }

        commit('detachUser', data)
    },

    /**
     * Отметка пользователя выбранным
     * @param commit
     * @param state
     * @param data {object}:
     *      data.list {string} - наименование state из которого удаляем
     *      data.id {string} - идентификатор (ключ) пользователя, по умолчанию email
     * @returns {*}
     */
    selectUser: ({commit, state}, data) => {
        let userDataCopy = _.cloneDeep(state[data.list][data.id]);

        switch (data.list) {
            case 'portalUsers':
                if (getters.isBlockedByUserLimit(state)) {
                    commit('showUserLimitExceededModal')
                    return;
                }
                commit('addUser', {
                    list: 'attachingUsers',
                    data: {id: data.id, ...userDataCopy},
                })
                break;
        }

        commit('selectUser', {list: data.list, id: data.id})
    },

    /**
     * Отмена метки пользователя `выбранный`
     * @param commit
     * @param data {object}:
     *      data.list {string} - наименование state из которого удаляем
     *      data.id {string} - идентификатор (ключ) пользователя, по умолчанию email
     * @returns {*}
     */
    deselectUser: ({commit}, data) => {
        commit('deselectUser', data);

        switch (data.list) {
            case 'portalUsers':
                commit('detachUser', {
                    list: 'attachingUsers',
                    id: data.id,
                });
                break;
        }
    },

    /**
     * Управление показом модального окна выбора пользователей
     * @param commit
     * @returns {*}
     */
    showUserSelectModal: ({commit}) => commit('showUserSelectModal'),
    hideUserSelectModal: ({commit}) => commit('hideUserSelectModal'),

    /**
     * Управление показом модального окна подтверждения
     * @param commit
     * @returns {*}
     */
    showConfirmationModal: ({commit}) => commit('showConfirmationModal'),
    hideConfirmationModal: ({commit}) => commit('hideConfirmationModal'),

    /**
     * Добавление нового пользователя в список прикрепляемых
     * @param commit
     * @param state
     * @param user - пользователь
     * @returns {*}
     */
    addAttachingUser: ({commit, state}, user) => {
        let isAttachedAlready = !!state.attachedUsers[user.id],
            isAttachingAlready = !!state.attachingUsers[user.id],
            isDetachingAlready = !!state.detachingUsers[user.id],
            isPendingInvite = !!state.pendingInvites[user.id],
            shouldBeIgnored = isAttachedAlready || isAttachingAlready || isPendingInvite;

        if (shouldBeIgnored) {
            return;
        }

        if (getters.isBlockedByUserLimit(state)) {
            commit('showUserLimitExceededModal')
            return;
        }

        if (isDetachingAlready) {
            commit('detachUser', {
                list: 'detachingUsers',
                id: user.id,
            });
        } else {
            commit('addUser', {
                list: 'attachingUsers',
                data: user
            });
        }
    },

    /**
     * Установка текущего пользователя базы
     * @param commit
     * @param userEmail
     * @returns {*}
     */
    setCurrentUser: ({commit}, userEmail) => {
        commit('setCurrentUser', userEmail)
        commit('disableUser', {
            list: 'attachedUsers',
            id: userEmail,
        });
    },

    setOwnerUser: ({commit}, userEmail) => {
        if (!userEmail) return;

        commit('setOwnerUser', userEmail);

        commit('ownerUser', {
            list: 'attachedUsers',
            id: userEmail,
        });

        commit('disableUser', {
            list: 'attachedUsers',
            id: userEmail,
        });
    },

    /**
     * Установка лимита пользователей для базы
     * @param commit
     * @param userLimit
     * @returns {*}
     */
    setUserLimit: ({commit}, userLimit) => commit('setUserLimit', userLimit),

    /**
     * Управление показом модального окна превышения лимита пользователей
     * @param commit
     * @returns {*}
     */
    showUserLimitExceededModal: ({commit}) => commit('showUserLimitExceededModal'),
    hideUserLimitExceededModal: ({commit}) => commit('hideUserLimitExceededModal'),

    /**
     * Очистка списка прикрепляемых пользователей
     * @param commit
     * @returns {*}
     */
    clearAttachingUsers: ({commit}) => commit('clearAttachingUsers'),
};

const mutations = {
    setTrans: (state, trans) => {
        Vue.set(state, 'trans', trans);
    },

    setAttachedUsers: (state, users) => {
        state.attachedUsers = _.cloneDeep(users);
    },

    setPortalUsers: (state, users) => {
        state.portalUsers = users;
    },

    setPendingInvites: (state, invites) => {
        state.pendingInvites = invites;
    },

    detachUser: (state, { list, id }) => {
        Vue.delete(state[list], id);
    },

    selectUser: (state, { list, id }) => {
        Vue.set(state[list][id], 'isSelected', true);
    },
    deselectUser: (state, { list, id }) => {
        Vue.set(state[list][id], 'isSelected', false);
    },

    disableUser: (state, { list, id }) => {
        Vue.set(state[list][id], 'isDisabled', true);
    },

    ownerUser: (state, { list, id }) => {
        Vue.set(state[list][id], 'isOwner', true);
    },

    showUserSelectModal: state => {
        state.isUserSelectModalShown = true;
    },
    hideUserSelectModal: state => {
        state.isUserSelectModalShown = false;
    },

    showConfirmationModal: state => {
        state.isConfirmationModalShown = true;
    },
    hideConfirmationModal: state => {
        state.isConfirmationModalShown = false;
    },

    addUser: (state, { list, data }) => {
        Vue.set(state[list], data.id, data);
    },

    setCurrentUser: (state, userEmail) => {
        state.currentUser = userEmail;
    },

    setOwnerUser: (state, userEmail) => {
        state.ownerUser = userEmail;
    },

    setUserLimit: (state, userLimit) => {
        state.userLimit = userLimit;
    },

    showUserLimitExceededModal: state => {
        state.isUserLimitExceededModalShown = true;
    },

    hideUserLimitExceededModal: state => {
        state.isUserLimitExceededModalShown = false;
    },

    clearAttachingUsers: state => {
        state.attachingUsers = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
